var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("All Paid Sick Leave Requests")]),_c('v-spacer'),_c('new-request-button')],1),_c('requests-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }